/**
 * Entity Type Enum
 * Defines all entity types in the backend architecture system
 */
export enum EntityType {
    MODEL = "model",
    FUNCTION = "function",
    SERVICE = "service",
    MIDDLEWARE = "middleware",
    ENDPOINT = "endpoint",
}

/**
 * Entity Type Labels (for UI display)
 */
export const EntityTypeLabel: Record<EntityType, string> = {
    [EntityType.MODEL]: "Model",
    [EntityType.FUNCTION]: "Function",
    [EntityType.SERVICE]: "Service",
    [EntityType.MIDDLEWARE]: "Middleware",
    [EntityType.ENDPOINT]: "Endpoint",
};

/**
 * Check if entity type is valid
 */
export function isValidEntityType(type: string): type is EntityType {
    return Object.values(EntityType).includes(type as EntityType);
}

